import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/search`;

export class Search {
  static async search(searchData, params) {
    try {
      const { profileId = null, ...queryParams } = params;

      const response = await axios.post(`${BASE_URL}`, searchData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params: queryParams,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async multiSearch(searchData, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/multi`, searchData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getStateCounts(searchData, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/statecounts`, searchData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
  // Export search results
  static async exportResults(searchData, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/export`, searchData, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
        responseType: 'blob',
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getStateCodes(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/stateCodes`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocument(documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/doc/${documentId}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentFromRepository(repositoryId, documentId, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/doc/${repositoryId}/${documentId}`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
